import { SvgIcon } from '@mui/material';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import trainingDark from 'assets/icons/svg/Training-dark.svg';
 * import training from 'assets/icons/svg/Training.svg';
 */

// ==============================|| TRAINING ICON SVG ||============================== //

const TrainingIcon = ({ reverse, ...others }: { reverse?: boolean }) => {
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? trainingDark : training} alt="icon logo" width="100" />
     *
     */
    <SvgIcon {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor">
        <path d="M718-145 569-295l149-150 42 43-76 77 196 1v60l-196-1 76 77-42 43Zm-578-15q-24 0-42-18t-18-42v-147q0-24 18-42t42-18h269q24 0 42 18t18 42v147q0 24-18 42t-42 18H140Zm0-60h269v-147H140v147Zm102-297-42-42 76-78H80v-60h196l-76-77 42-42 149 149-149 150Zm309-16q-24 0-42-18t-18-42v-147q0-24 18-42t42-18h269q24 0 42 18t18 42v147q0 24-18 42t-42 18H551Zm0-60h269v-147H551v147ZM409-220v-147 147Z" />
      </svg>
    </SvgIcon>
  );
};

export default TrainingIcon;
